module.exports = __webpack_public_path__ + "static/futura-bold-4c62644b159530ff6214336f8cfb1d32.ttf";